export default __webpack_public_path__ + "static/media/socialFacebookdark.6f3d5fed.svg";